export enum ITableSortDirection {
  Ascending = 'ASC',
  Descending = 'DSC',
  None = '',
}

export interface ITableSort {
  active?: string;
  direction?: ITableSortDirection;
}
